import React from 'react'
import { Modal } from 'antd'
import { messageTypes } from '../../../../actions/messages'
import { takeElementWithIdFromArr } from '../../../../actions/helpers'
import StyledQuizForm from '../../../../styledComponents/sections/settings/quiz/quizForm'

class QuizModalSettings extends React.Component {
  state = {
    singleData: {}
  }

  handleCancel = () => {
    const { setDataId, showAddRecordModal } = this.props
    setDataId(null)
    showAddRecordModal(false)
  }

  componentDidUpdate (prevProps, prevState) {
    const { dataId, data } = this.props
    if (prevProps.dataId !== dataId) {
      const singleData = takeElementWithIdFromArr(dataId, data)
      this.setState({ singleData })
    }
  }

  render () {
    const {
      language, dataId, isNewRecord, loading,
      updateRecord, addRecord, scenarios
    } = this.props
    const { singleData } = this.state
    return (
      <div>
        <Modal
          visible={!!(dataId || isNewRecord)}
          title={
            (isNewRecord && messageTypes[language].new_quiz) ||
            (
              singleData &&
              singleData.scenario &&
              singleData.scenario.name &&
              singleData.scenario.name[language])
          }
          onCancel={this.handleCancel}
          footer={null}
          width={800}
        >
          <StyledQuizForm
            scenarios={scenarios}
            isNewRecord={isNewRecord}
            data={singleData || {}}
            language={language}
            onCancel={this.handleCancel}
            updateRecord={updateRecord}
            addRecord={addRecord}
            loading={loading}
          />
        </Modal>
      </div>
    )
  }
}

export default QuizModalSettings
